import { createContext, useState, useContext } from 'react';

export type HeatMapComparison = {
  countryCodes: string[];
  display?: boolean;
  syncVersion?: number;
};

export type PoiComparison = {
  studyIds: string[];
  display?: boolean;
  syncVersion?: number;
};

type ComparisonContextType = {
  heatMapComparison: HeatMapComparison;
  poiComparison: PoiComparison;
  setHeatMapComparison: (heatMapComparison: HeatMapComparison) => void;
  setPoiComparison: (poiComparison: PoiComparison) => void;
};

export const ComparisonContext = createContext<ComparisonContextType>({
  heatMapComparison: { countryCodes: [] },
  poiComparison: { studyIds: [] },
  setHeatMapComparison: () => {},
  setPoiComparison: () => {},
});

interface Props {
  children: React.ReactNode;
}

export const useComparisonProviderContext = () => {
  const {
    heatMapComparison,
    poiComparison,
    setHeatMapComparison,
    setPoiComparison,
  } = useContext(ComparisonContext);

  return {
    heatMapComparison,
    poiComparison,
    setHeatMapComparison,
    setPoiComparison,
  };
};

export function ComparisonProvider(props: Props) {
  const [heatMapComparison, setHeatMapComparison] = useState<HeatMapComparison>(
    { countryCodes: [] },
  );
  const [poiComparison, setPoiComparison] = useState<PoiComparison>({
    studyIds: [],
  });

  return (
    <ComparisonContext.Provider
      value={{
        heatMapComparison,
        poiComparison,
        setHeatMapComparison,
        setPoiComparison,
      }}
    >
      {props.children}
    </ComparisonContext.Provider>
  );
}
